import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgAlignLeft = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 10H3m17-4H3m17 8H3m13 4H3"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAlignLeft)
export default ForwardRef
